import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserInfo } from '../../store/User/reducer';
import { getSocket, newSessionId } from '../../../helpers/SocketsClientConfigHelper';
import { ROOT_URL } from '../../constants/endpoints';
import { getCurrentLanguage } from '../../../helpers/LangHelper';
import { getSessionIdStored, storeSessionId } from '../../../helpers/CookieHelper';

export const CONNECTION_EVENT_ACTION_VALUE = 'dashboard.user.connected';
export const DISCONNECTION_EVENT_PAYLOAD_VALUE = 'disconnect';
export const socketChannel = `sg-${process.env.ENVIRONMENT}`;

export const SocketsClientConfig = () => {
    const socket = getSocket()
    const user = useSelector(selectUserInfo);
    const [connected, toggleConnected] = useState<boolean>(false);

    const createChannelConnection = (userId: string, accountId: string): void => {
        const sessionIdStored = getSessionIdStored(userId);
        const sessionId = sessionIdStored || newSessionId;
        storeSessionId(userId, sessionId);
        const socketParams = {
            action: CONNECTION_EVENT_ACTION_VALUE,
            user_id: userId,
            account_id: accountId,
            session_id: sessionId,
        };
        socket.emit(socketChannel, socketParams);
        toggleConnected(true);
    };

    useEffect(() => {
        return () => {
            if (connected) {
                socket.off(socketChannel, onRedirectHandler);
            }
        };
    }, []);

    useEffect(() => {
        if (user) {
            const userId = user.userId;
            const accountId = user.accountId;
            const hasAllData = userId && accountId;
            if (hasAllData && !connected) {
                connectSocket(userId, accountId);
            }
        }
    }, [user]);

    const connectSocket = (userId: string, accountId: string): void => {
        createChannelConnection(userId, accountId);
        socket.on(socketChannel, onRedirectHandler);
    };

    const onRedirectHandler = (data: string) => {
        if (data === DISCONNECTION_EVENT_PAYLOAD_VALUE) {
            window.location.href = `${ROOT_URL}/${getCurrentLanguage()}/logout`;
        }
    };

    return null;
};
